

































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { GrantData, GrantSummary, IGrantSummary, ReportSchedule } from "@/entities";
import { AppConstants as _app} from "@/shared/app.constants";

@Component
export default class ScheduleComponent extends Vue {

    @Prop() title: string;
    @Prop() reports: Array<ReportSchedule>;
    header: any = [];    

    get headers() {
        // return _app.reportScheduleHeaders;
        this.header = _app.reportScheduleHeaders;
        this.header.map(x => {
            x.text = this.$t(x.text);
        });
        return this.header;
    }
    
}
